import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { RequestService } from '../request.service';
import { ResourceConfig } from '../../core/models/resource.config';
import { UserModel } from '../../models/user.model';
import { AuthRequestModel } from '../../models/auth-request.model';

@Injectable({
    providedIn: 'root'
})
export class AuthResource extends BaseResource<UserModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const requestService = inject(RequestService);

        super(
            new ResourceConfig<UserModel>({
                requestService,
                baseController: 'users/authenticate'
            })
        );
    }

    login(data: AuthRequestModel): Observable<UserModel> {
        return this.config.requestService.makePost<UserModel>(this.getUrl(''), data);
    }
}
